import { render, staticRenderFns } from "./wjt-radio.vue?vue&type=template&id=d99d0708&scoped=true"
import script from "./wjt-radio.vue?vue&type=script&lang=js"
export * from "./wjt-radio.vue?vue&type=script&lang=js"
import style0 from "./wjt-radio.vue?vue&type=style&index=0&id=d99d0708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99d0708",
  null
  
)

export default component.exports